<header class="header">
  <div class="container">
    <div class="header-content">
      <!-- Logo -->
      <div class="logo">
        <a href="#home" (click)="scrollToSection('home'); $event.preventDefault()" class="logo-link">
          <img [src]="getImageUrl('logos/main/la_joya.png')" alt="La Joya Park Resort" class="logo-img">
        </a>
      </div>

      <!-- Botón hamburger para móvil -->
      <button class="hamburger-menu" (click)="toggleMobileMenu()" [class.active]="isMobileMenuOpen">
        <span class="hamburger-line"></span>
        <span class="hamburger-line"></span>
        <span class="hamburger-line"></span>
      </button>

      <!-- Menú de navegación -->
      <nav class="nav-menu" [class.mobile-open]="isMobileMenuOpen">
        <ul class="nav-list">
          <li *ngFor="let item of menuItems" class="nav-item">
            <a 
              href="{{ item.link }}" 
              class="nav-link"
              (click)="scrollToSection(item.link.substring(1)); $event.preventDefault(); closeMobileMenu()"
            >
              {{ item.text }}
            </a>
          </li>
        </ul>
      </nav>

      <!-- Botón de afiliación -->
      <div class="header-action">
        <button class="btn btn-primary btn-affiliate">
          Afiliate
        </button>
      </div>
    </div>
  </div>
</header>
